







import { Component, Vue } from 'vue-property-decorator';
import Left from '@/components/Left.vue';
import Center from '@/components/Center.vue';

@Component({
  components: {
    Left,
    Center,
  },
})
export default class App extends Vue {
  public mounted() {
    /* this.$store.dispatch('requestData');
    this.$store.dispatch('requestFiles'); */
  }
}
